<template>
    <div style="">
        <v-flex xs12 pa-0 ma-0>
            <span :style="[isInvoiceA5Format ? {'font-size': '9px'} : {'font-size':'11px'}]">
                Tributo especial unificado (TEU) nos termos da lei da alínea 3 do artigo nr.28 Decreto-lei nr.70/VIII/2014 de Agosto de 2014.
            </span>
            <v-divider style="margin-top: 10px;"></v-divider>
            <span :style="[isInvoiceA5Format ? {'font-size': '9px'} : {'font-size':'11px'}]">
                Processado pelo programa <b>NHA FATURA</b> licenciado pelo contribuinte./ &copy;<b>Laciftech</b>
            </span>
        </v-flex>
    </div>
</template>

<script>
    export default {
        created () {
            
        },

        data(){
            return {

            }
        },

        props: {
            isInvoiceA5Format: {
                type: Boolean,
                default: false
            },
        },

        watch: {
            
        },

        computed: {

        },

        methods: {

        }
    }
</script>
